import React from 'react';
import { components, DropdownIndicatorProps } from 'react-select';

import { Icons } from '@icons/icons';

export const DropdownIndicator = (props: DropdownIndicatorProps) => {
	const menuIsOpen = props.selectProps.menuIsOpen;

	return (
		<components.DropdownIndicator {...props}>
			{menuIsOpen ? Icons.chevronUp() : Icons.chevronDown()}
		</components.DropdownIndicator>
	);
};
